import { useMemo } from 'react';
import {
  CustomFieldValidator,
  DEFAULT_SCAFFOLDER_FIELD_EXTENSIONS,
  FieldExtensionOptions,
} from '../../extensions';

/**
 * Returns the default rjsf fields validation for all the customized Pickers we have in witboost
 * @param additionalFields allows to provide additional fields, they will override the default Pickers with the same name
 * @returns
 */
export const useDefaultValidations = (
  additionalFields?: FieldExtensionOptions<any, any>[],
) => {
  return useMemo(() => {
    const additional = additionalFields ?? [];

    const customFieldValidatorsSync = Object.fromEntries(
      DEFAULT_SCAFFOLDER_FIELD_EXTENSIONS.concat(additional).map(
        ({ name, validation, asyncValidation }) => [
          name,
          asyncValidation === true
            ? undefined
            : (validation as CustomFieldValidator<any>),
        ],
      ),
    );

    const customFieldValidatorsAsync = Object.fromEntries(
      DEFAULT_SCAFFOLDER_FIELD_EXTENSIONS.concat(additional)
        .filter(({ asyncValidation }) => asyncValidation)
        .map(({ name, validation }) => [
          name,
          validation as CustomFieldValidator<any>,
        ]),
    );

    return { customFieldValidatorsSync, customFieldValidatorsAsync };
  }, [additionalFields]);
};
